import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TournamentListContainer from "../../containers/TournamentListContainer";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = theme => ({
  body: {
    marginTop: 64,
    [theme.breakpoints.down("xs")]: {
      marginTop: 56
    }
  }
});

const MainRoutes = props => (
  <div>
    <div className={props.classes.body}>
      <Switch>
        <Route
          path="/"
          exact
          render={() => (
            <TournamentListContainer
              user={props.user}
              userData={props.userData}
            />
          )}
        />
        <Route path="*" render={() => <Redirect to="/" />} />
      </Switch>
    </div>
  </div>
);

MainRoutes.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MainRoutes);
